export const VIEW_WIDTH = 450;
export const VIEW_HEIGHT = 800;
export const WORLD_WIDTH = 1800;
export const WORLD_HEIGHT = 2800;
export const PROTOTYPE_DURATION_SECONDS = 180;

export const COLORS = {
  void: 0x080b0a,
  ground: 0x151a17,
  groundLight: 0x20251f,
  grid: 0x2b3028,
  iron: 0x7f8580,
  ironDark: 0x303633,
  burgundy: 0x67323a,
  parchment: 0xd4c49c,
  parchmentDark: 0x8c7957,
  blood: 0x8f2f32,
  ember: 0xd87a36,
  xp: 0x7ec5b7,
  holy: 0xe8dba9,
} as const;
